import { render } from "./custom-table-cell.vue?vue&type=template&id=2568a57c&scoped=true"
import script from "./custom-table-cell.vue?vue&type=script&lang=js"
export * from "./custom-table-cell.vue?vue&type=script&lang=js"

import "./custom-table-cell.vue?vue&type=style&index=0&id=2568a57c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2568a57c"]])

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd});
